var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom icon/check_circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99967 1.33325C4.31967 1.33325 1.33301 4.31992 1.33301 7.99992C1.33301 11.6799 4.31967 14.6666 7.99967 14.6666C11.6797 14.6666 14.6663 11.6799 14.6663 7.99992C14.6663 4.31992 11.6797 1.33325 7.99967 1.33325Z",
    fill: "#489F55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.06 5.05322L6.66667 9.44656L4.94 7.72656L4 8.66656L6.66667 11.3332L12 5.99989L11.06 5.05322Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUploadSuccess);
export default __webpack_public_path__ + "static/media/data-upload-success.2b2beeba7fd69da2397b85fe4bdbd28c.svg";
export { ForwardRef as ReactComponent };